class ProductTypeSerializer {
  static deSerialize(data) {
    let productTypeData = {};
    if (data.GruposCaracteristicasCabezal) {
      productTypeData = data.GruposCaracteristicasCabezal;
    }
    return {
      description: productTypeData.GCCDescripcionCorta,
      id: String(productTypeData.GCCID),
      name: productTypeData.GCCNombre,
    };
  }
}

export { ProductTypeSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ProductTypeSerializer.js